import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// ============ INTERFACE ============

export interface OverflowStateInterface {
  overflowActive: boolean;
  voucherCode: string;
  voucherValue: number;
  voucherDescription: string;
}

// ============ INIT STATE ============

const initialState: OverflowStateInterface = {
  overflowActive: false,
  voucherCode: '',
  voucherValue: 0,
  voucherDescription: '',
};

// ========= SLICE ==========

export const overflowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setOverflowActive: (state: OverflowStateInterface, action: PayloadAction<{ active: boolean, voucherCode: string, voucherValue: number, voucherDescription: string }>) => {
      state.overflowActive = action.payload.active;
      state.voucherCode = action.payload.voucherCode;
      state.voucherValue = action.payload.voucherValue;
      state.voucherDescription = action.payload.voucherDescription;
    },
  }
})

export const { setOverflowActive } = overflowSlice.actions;

export default overflowSlice.reducer;